const stateGenerator = {
  generateInitialState(itemsPerPage = 0){
    return {
      // Pagination Redux Initial State
      previousPage: null,
      currentPage: 1,
      nextPage: 2,
      itemsPerPage,
      pageItems: [],
      totalItems: 0,
    }
  }
}

export default stateGenerator
